export type TerminBlockStatus<T> =
    | { kind: "loading" }
    | { kind: "error"; message: string }
    | { kind: "empty"; data: T[]; error?: string }
    | { kind: "ready"; data: T[]; refreshing: boolean; error?: string };

/** Hält bereits geladene Daten während einer Aktualisierung sichtbar. */
export function terminBlockStatus<T>(
    data: T[] | null,
    loading: boolean,
    error: string | null,
): TerminBlockStatus<T> {
    if (error && data === null) return { kind: "error", message: error };
    if (data === null) return { kind: "loading" };
    if (data.length === 0) return { kind: "empty", data, ...(error ? { error } : {}) };
    return { kind: "ready", data, refreshing: loading, ...(error ? { error } : {}) };
}

/** Eine Wiederholung bleibt exakt auf der zuvor fehlgeschlagenen Zeitfenster-Stufe. */
export function retryTerminStufe<T>(fehlgeschlagen: T | null, aktuell: T): T {
    return fehlgeschlagen ?? aktuell;
}
